const getters = {
    /** User variables */
    FullName: (state) => state.user.FullName,
    NumSystem: (state) => state.user.Num_System,
    ImageUrl: (state) => state.user.ImageUrl,

    userInfo: (state) => state.user.userInfo,
    token: (state) => state.user.token,
    roles: (state) => state.user.roles,
    branches: (state) => state.user.branches,
    permissions: (state) => state.user.permissions,
    currentBranch: (state) => state.user.currentBranch,
    isAdmin: (state) => state.user.isAdmin,
    isReporter: (state) => state.user.isReporter,
    isModir: (state) => state.user.isModir,
    isHesabdar: (state) => state.user.isHesabdar,
    isAshpaz: (state) => state.user.isAshpaz,
    isEnduser: (state) => state.user.isEnduser,
    isModirAdmin: (state) => state.user.isModirAdmin,
    currentRole: (state) => state.user.currentRole,
    autoDelivery: (state) => state.user.autoDelivery,
    /** global variables */
    headerTitle: (state) => state.global.headerTitle,
    showDetails: (state) => state.global.showDetails,
    isMobile: (state) => state.global.mobile,
    snackbar: (state) => state.global.snackbar,
    progress: (state) => state.global.progress,
    apiRunning: (state) => state.global.apiRunning,
    menuOptions: (state) => state.user.menuOptions,
    dialog: (state) => state.global.dialog,
    searchInput: (state) => state.global.searchInput,
    tableText: (state) => state.global.tableText,
    selectedMenu: (state) => state.global.selectedMenu,
    headerProps: (state) => state.global.headerProps,
    selectedFard: (state) => state.global.selectedFard,
    pagination: (state) => state.global.pagination


    /** message variables */

};
export default getters;